import { render, staticRenderFns } from "./ModerateList.vue?vue&type=template&id=3263f9e0&scoped=true"
import script from "./ModerateList.vue?vue&type=script&lang=js"
export * from "./ModerateList.vue?vue&type=script&lang=js"
import style0 from "./ModerateList.vue?vue&type=style&index=0&id=3263f9e0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3263f9e0",
  null
  
)

export default component.exports